import { memo } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { TokenInfoDrawer } from "./TokenInfoDrawer";

/**
 * App shell. Two-column layout:
 *
 *   ┌────┬────────────────────────────┐
 *   │    │  TopBar (h-10)             │
 *   │ S  ├────────────────────────────┤
 *   │ id │                            │
 *   │ e  │  <Outlet />                │
 *   │ ba │                            │
 *   │ r  │                            │
 *   └────┴────────────────────────────┘
 *
 * On mobile (< 768 px) the sidebar becomes a left-edge overlay drawer
 * controlled by ``useUiStore.mobileSidebarOpen``; the hamburger lives
 * in ``TopBar``. On desktop the sidebar sits inline (60 px collapsed
 * or 240 px expanded — see ``useUiStore.sidebarCollapsed``).
 *
 * Pre-2026-05-02 this was a horizontal ``<header>`` + main layout
 * with the nav baked into the header. Migrated to a Discord/Slack-
 * style left rail so adding new pages no longer crowds the top bar
 * and the operator can focus on the chart/table area without nav
 * chrome stealing 56 px of vertical real estate.
 */
export const Layout = memo(function Layout() {
  return (
    <div className="flex h-full min-h-0 bg-bg text-text1">
      <Sidebar />
      <div className="flex flex-1 min-w-0 min-h-0 flex-col">
        <TopBar />
        <main className="flex-1 min-h-0 overflow-hidden">
          <Outlet />
        </main>
      </div>
      {/* Global slide-in token-info drawer. Mounted once so any page
          (Spreads, Orderbooks, Dashboard panels) can call
          ``useTokenDrawer.openFor(...)`` to surface details for the
          clicked entity. Returns null while ``open === false`` so
          there's no rendering cost when idle. */}
      <TokenInfoDrawer />
    </div>
  );
});
